import { memo } from 'react'

import * as Popover from '@radix-ui/react-popover'
import { Editor } from '@tiptap/react'
import {
  TbAlignCenter,
  TbAlignJustified,
  TbAlignLeft,
  TbAlignRight,
  TbDotsVertical,
  TbSubscript,
  TbSuperscript,
} from 'react-icons/tb'

import { Surface } from '@/components/common/TextArea/RichTextArea/menus/components/Surface'
import { Toolbar } from '@/components/common/TextArea/RichTextArea/menus/components/Toolbar'
import {
  useTextMenuCommands,
  useTextMenuState,
} from '@/components/common/TextArea/RichTextArea/menus/TextMenu/hooks'

const MemoButton = memo(Toolbar.Button)

interface MoreOptionsPopoverProps {
  editor: Editor
}

export const MoreOptionsPopover: React.FC<MoreOptionsPopoverProps> = ({
  editor,
}) => {
  const commands = useTextMenuCommands({ editor })
  const states = useTextMenuState({ editor })

  const handlePopoverOpenAutoFocus = (event: Event) => {
    event.preventDefault()
  }

  return (
    <Popover.Root modal={true}>
      <Popover.Trigger asChild={true}>
        <MemoButton>
          <TbDotsVertical className="w-4 h-4" />
        </MemoButton>
      </Popover.Trigger>
      <Popover.Content
        side="top"
        sideOffset={2}
        onOpenAutoFocus={handlePopoverOpenAutoFocus}
      >
        <Surface className="flex items-center gap-x-1 p-1 w-fit shadow-md">
          <MemoButton
            tooltip="Subscript"
            onClick={commands.onSubscript}
            isActive={states.isSubscript}
          >
            <TbSubscript className="w-4 h-4" />
          </MemoButton>
          <MemoButton
            tooltip="Superscript"
            onClick={commands.onSuperscript}
            isActive={states.isSuperscript}
          >
            <TbSuperscript className="w-4 h-4" />
          </MemoButton>
          <Toolbar.Divider />
          <MemoButton
            tooltip="Align left"
            onClick={commands.onAlignLeft}
            isActive={states.isAlignLeft}
          >
            <TbAlignLeft className="w-4 h-4" />
          </MemoButton>
          <MemoButton
            tooltip="Align center"
            onClick={commands.onAlignCenter}
            isActive={states.isAlignCenter}
          >
            <TbAlignCenter className="w-4 h-4" />
          </MemoButton>
          <MemoButton
            tooltip="Align right"
            onClick={commands.onAlignRight}
            isActive={states.isAlignRight}
          >
            <TbAlignRight className="w-4 h-4" />
          </MemoButton>
          <MemoButton
            tooltip="Justify"
            onClick={commands.onAlignJustify}
            isActive={states.isAlignJustify}
          >
            <TbAlignJustified className="w-4 h-4" />
          </MemoButton>
        </Surface>
      </Popover.Content>
    </Popover.Root>
  )
}
